/**
 * Financial unit conversions shared across FI panels.
 *
 * Used by manager_income_financials_container and
 * renter_verified_financials_container to derive a weekly income figure when
 * the API only returns monthly. Single source of truth for the
 * monthly→weekly approximation.
 */

export const WEEKS_PER_YEAR = 52
export const MONTHS_PER_YEAR = 12

export function monthlyToWeekly(monthlyIncome: number): number {
  return Math.round((monthlyIncome * MONTHS_PER_YEAR) / WEEKS_PER_YEAR)
}
